/*
  회사 정보
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Info } from 'components';

import * as companyAPI_Action from 'actions/company';
import cm from 'helpers/commons';
import storage from "../helpers/storage";

class CompanyInfo extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    cm.mainTitle('회사정보');
    this.companyInfo();
  }

  //회사정보 조회
  companyInfo = async () => {
    const { companyAPI } = this.props;
    const companyId = storage.get('companyInfo');
    const { comId } = companyId || {};

    try {
      await companyAPI.companyInfoSel(comId);
    } catch (e) {
      console.log('##### companyInfo : ', e);
    }
  };

  render() {
    const { companyInfo } = this.props;
    const { data } = companyInfo || {};
    const companyInfoObj = {
      Info: data
    };

    return (
      <main>
        <Info companyInfoObj={companyInfoObj} />
      </main>
    );
  }
}

CompanyInfo = connect(
  (state) => ({
    companyInfo: state.company.info
  }),
  (dispatch) => ({
    companyAPI: bindActionCreators(
      {
        companyInfoSel: companyAPI_Action.CompanyInfoSel
      },
      dispatch
    )
  })
)(CompanyInfo);

export default CompanyInfo;
